import { render, staticRenderFns } from "./floating-dock-toggle.vue?vue&type=template&id=acce4f1e&scoped=true&"
import script from "./floating-dock-toggle.vue?vue&type=script&lang=js&"
export * from "./floating-dock-toggle.vue?vue&type=script&lang=js&"
import style0 from "./floating-dock-toggle.vue?vue&type=style&index=0&id=acce4f1e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acce4f1e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFabTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VFabTransition})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acce4f1e')) {
      api.createRecord('acce4f1e', component.options)
    } else {
      api.reload('acce4f1e', component.options)
    }
    module.hot.accept("./floating-dock-toggle.vue?vue&type=template&id=acce4f1e&scoped=true&", function () {
      api.rerender('acce4f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/components/floating-dock-toggle/floating-dock-toggle.vue"
export default component.exports